import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable max-len */
import { CONTACT_EMAIL } from './constants'; // GENDER

export var WOMEN = 'Women';
export var MEN = 'Men';
export var KIDS = 'Kids';
export var UNISEX = 'Unisex';
export var GENDERS = {
  WOMEN: WOMEN,
  MEN: MEN,
  UNISEX: UNISEX
};
export var TEXT = {
  bra: {
    colLabel: 'Band Size',
    guide: 'In between sizes? Size down for more support.',
    title: 'Sports Bra Sizes'
  },
  fit: {
    colLabel: 'Body Part',
    guide: "Measurements are standard, but bodies? Not so much. Email <a href=\"mailto:".concat(CONTACT_EMAIL, "?subject=[Size Guide] Help with sizing\">").concat(CONTACT_EMAIL, "</a> to get more specific."),
    sizeDown: 'This runs big, we recommend sizing down.',
    sizeUp: 'This runs small, we recommend sizing up.',
    title: 'Find Your Fit'
  },
  shoes: {
    guide: 'Fits true to size. Take your normal size. Only available in full sizes, go down to the nearest whole size if you take a half size.',
    title: 'Shoes'
  }
};
export var FIT_RATINGS = ['Runs Small', 'Runs a Bit Small', 'Just Right', 'Runs a Bit Large', 'Runs Large'];
export var SIZES = ['XS', 'S', 'M', 'L', 'XL'];
export var SIZES_EXTENDED = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
export var SIZE_NAMES = ['Extra Small', 'Small', 'Medium', 'Large', 'Extra Large'];
export var SIZE_NAME_MAP_SMALL = {
  XS: SIZE_NAMES[0],
  S: SIZE_NAMES[1],
  M: SIZE_NAMES[2],
  L: SIZE_NAMES[3],
  XL: SIZE_NAMES[4]
};
export var getSizeVerbose = function getSizeVerbose(label) {
  return SIZE_NAME_MAP_SMALL[label] || label;
};
export var SIZE_NAME_MAP = _objectSpread(_objectSpread({}, SIZE_NAME_MAP_SMALL), {}, {
  XXS: 'XXS',
  XXL: 'XXL',
  XXXL: 'XXXL',
  'Extra Small': 'XS',
  Small: 'S',
  Medium: 'M',
  Large: 'L',
  'Extra Large': 'XL'
}); // SHOES

export var EU_SHOES = {
  category: 'Shoes',
  inches: false,
  sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'],
  type: 'Europe'
};
export var US_WOMEN_SHOES = {
  category: 'Shoes',
  inches: false,
  sizes: ['6', '6½', '7½', '8½', '9', '9½', '10', '10½', '12', '13'],
  type: "US \u2013 ".concat(WOMEN)
};
export var US_MEN_SHOES = {
  category: 'Shoes',
  inches: false,
  sizes: ['4½', '5', '6', '7 ', '7½', '8', '8½', '9', '10½', '11½'],
  type: "US \u2013 ".concat(MEN)
};
export var WOMEN_SIZES = [{
  category: 'Chest',
  inches: true,
  sizes: ['31 – 33', '33 – 35', '35 – 37', '37 – 39', '39 – 41']
}, {
  category: 'Waist',
  inches: true,
  sizes: ['24 – 26', '26 – 28', '28 – 30', '30 – 32', '32 – 34']
}, {
  category: 'Hips',
  inches: true,
  sizes: ['33½ – 35½', '35½ – 37½', '37½ – 39½', '39½ – 41½', '41½ – 43½']
}, {
  category: 'Dress',
  inches: false,
  sizes: ['0 – 2', '4 – 6', '8 – 10', '10 – 12', '12 – 14']
}, {
  category: 'Torso',
  inches: true,
  sizes: ['56 – 58', '58½ – 60½', '61 – 63', '63½ – 65½', '66 – 68']
}, _objectSpread({}, US_WOMEN_SHOES)];
export var WOMEN_SIZES_EXTENDED = [{
  category: 'Chest',
  inches: true,
  sizes: ['29 - 31', '31 - 33', '33 - 35', '35 - 37', '37 - 39 1/2', '39 1/2 - 42', '42 - 44 1/2', '44 1/2 - 47']
}, {
  category: 'Waist',
  inches: true,
  sizes: ['22 - 24', '24 - 26', '26 - 28', '28 - 30', '30 - 32 1/2', '32 1/2 - 35', '35 - 37 1/2', '37 1/2 - 40']
}, {
  category: 'Hips',
  inches: true,
  sizes: ['31 1/2 - 33 1/2', '33 1/2 - 35 1/2', '35 1/2 - 37 1/2', '37 1/2 - 39 1/2', '39 1/2 - 42', '42 - 44 1/2', '44 1/2 - 47', '47 1/2 - 50']
}, {
  category: 'Dresses',
  inches: false,
  sizes: ['00 - 0', '0 - 2', '4 - 6', '8 - 10', '10 - 12', '14 - 16', '16 - 18', '18 -20']
}, _objectSpread({}, US_WOMEN_SHOES)];
export var MEN_SIZES = [{
  category: 'Chest',
  inches: true,
  sizes: ['35 – 37', '37 – 39', '39 – 41', '41 – 43', '43 – 46']
}, {
  category: 'Waist',
  inches: true,
  sizes: ['29 – 31', '31 – 33', '33 – 35', '36 – 38', '38 – 41']
}, {
  category: 'Hips',
  inches: true,
  sizes: ['34 – 36', '36 – 38', '38 – 40', '40 – 42', '42 – 45']
}, _objectSpread({}, US_MEN_SHOES)];
export var MEN_SIZES_EXTENDED = [{
  category: 'Chest',
  inches: true,
  sizes: ['33 - 35', '35 - 37', '37 - 39', '39 - 41', '41 - 43 1/2', '43 1/2 - 46', '46 - 48 1/2', '48 1/2 - 51']
}, {
  category: 'Waist',
  inches: true,
  sizes: ['27 - 29', '29 - 31', '31 - 33', '33 - 35', '35 - 37 1/2', '37 1/2 - 40', '40 - 42 1/2', '42 1/2 - 45']
}, {
  category: 'Hips',
  inches: true,
  sizes: ['32 - 34', '34 - 36', '36 - 38', '38 - 40', '40 - 42 1/2', '42 1/2 - 45', '45 - 47 1/2', '47 1/2 - 50']
}, _objectSpread({}, US_MEN_SHOES)];
export var UNISEX_SIZES = [{
  category: 'Chest',
  inches: true,
  sizes: ['35 – 37', '37 – 39', '39 – 41', '41 – 43', '43 – 46']
}, {
  category: 'Waist',
  inches: true,
  sizes: ['29 – 31', '31 – 33', '33 – 35', '36 – 38', '38 – 41']
}, {
  category: 'Hips',
  inches: true,
  sizes: ['34 – 36', '36 – 38', '38 – 40', '40 – 42', '42 – 45']
}];
export var UNISEX_SIZES_EXTENDED = [{
  category: 'Chest',
  inches: true,
  sizes: ['33 - 35', '35 - 37', '37 - 39', '39 - 41', '41 - 43 1/2', '43 1/2 - 46', '46 - 48 1/2', '48 1/2 - 51']
}, {
  category: 'Waist',
  inches: true,
  sizes: ['27 - 29', '29 - 31', '31 - 33', '33 - 35', '35 - 37 1/2', '37 1/2 - 40', '40 - 42 1/2', '42 1/2 - 45']
}, {
  category: 'Hips',
  inches: true,
  sizes: ['32 - 34', '34 - 36', '36 - 38', '38 - 40', '40 - 42 1/2', '42 1/2 - 45', '45 - 47 1/2', '47 1/2 - 50']
}];
export var RAPHA_SIZES = [{
  category: 'Chest',
  inches: true,
  sizes: ['32 – 33½', '34 – 35½', '36 – 37½', '38 – 39½', '40 – 41½']
}, {
  category: 'Waist',
  inches: true,
  sizes: ['25 – 26½', '27 – 28½', '29 – 30½', '31 – 32½', '33 – 34½']
}, {
  category: 'Hips',
  inches: true,
  sizes: ['34 – 36', '36 – 37½', '38 – 39½', '40 – 41½', '42 – 43½']
}];
export var BRA_MEASUREMENTS = {
  category: 'Measurements',
  sizes: ['30', '32', '34', '36', '38', '40', '42', '44']
};
export var BRA_SIZES = [{
  category: 'AA',
  sizes: [].concat(SIZES_EXTENDED)
}, {
  category: 'A',
  sizes: [].concat(SIZES_EXTENDED)
}, {
  category: 'B',
  sizes: [].concat(SIZES_EXTENDED)
}, {
  category: 'C',
  sizes: [].concat(SIZES, ['XL', 'XXL', 'XXXL'])
}, {
  category: 'D',
  sizes: [].concat(SIZES, ['XXL', 'XXXL', 'XXXL'])
}, {
  category: 'DD',
  sizes: ['S'].concat(_toConsumableArray(SIZES.filter(function (size) {
    return size !== 'XS';
  })), ['XXL', 'XXXL', 'XXXL'])
}]; // export const BRA_SIZES_FLIPPED = [
//   {
//     category: 'AA',
//     sizes: ['30 – 32"', '34"', '36"', '38 – 40"', 'N/A'],
//   },
//   {
//     category: 'A',
//     sizes: ['30 – 32"', '34"', '36"', '38"', '40"'],
//   },
//   {
//     category: 'B',
//     sizes: ['30 – 32"', '34"', '36"', '38"', '40"'],
//   },
//   {
//     category: 'C',
//     sizes: ['30"', '32"', '34 - 36"', '38"', '40"'],
//   },
//   {
//     category: 'D',
//     sizes: ['30"', '32"', '34 - 36"', '38"', '40"'],
//   },
//   {
//     category: 'DD',
//     sizes: ['N/A', '30 - 32"', '34"', '36"', '38 - 40"'],
//   },
// ];

export var SIZES_KIDS = ['6-12M', '12-18M', '18-24M', '3T', '4T', '5T'];
export var KIDS_SIZES = [{
  category: 'Chest',
  inches: true,
  sizes: ['16.5 - 18', '18 - 20', '20 - 21', '21 - 22', '22 - 23', '22.5 - 23']
}, {
  category: 'Waist',
  inches: true,
  sizes: ['16.5 - 17.5', '17.5 - 18.5', '18.5 - 19', '19 - 21', '21 - 21.5', '21.5 - 22.5']
}, {
  category: 'Hips',
  inches: true,
  sizes: ['17 - 18', '18 - 19', '19 - 20', '20 - 21', '21 - 22', '22 - 23']
}];